import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const verificationRecordService = createApi({
    reducerPath: 'verificationRecordService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['VerificationRecord'],
    endpoints: (builder) => ({
        getAllVerificationRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.verificationRecordController.getAll}/${body.page}/${body.size}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        searchVerificationRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.verificationRecordController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveVerificationRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.verificationRecordController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateVerificationRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.verificationRecordController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteVerificationRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.verificationRecordController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: {
                        Authorization: `Bearer ${body.token}`
                    },
                };
            },
        }),
        getVerificationRecordById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.verificationRecordController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllVerificationRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.verificationRecordController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadVerificationRecord: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.verificationRecordController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});

export const {
    useGetAllVerificationRecordMutation,
    useSearchVerificationRecordMutation,
    useSaveVerificationRecordMutation,
    useUpdateVerificationRecordMutation,
    useDeleteVerificationRecordMutation,
    useGetVerificationRecordByIdMutation,
    useFindAllVerificationRecordMutation,
    useBulkUploadVerificationRecordMutation,
} = verificationRecordService;
